import { Box } from 'grommet'
import styled from 'styled-components'

export const Wrapper = styled(Box)`
  ${({ theme }) => theme.below.laptop`
    padding: 0 ${theme.spaces[3]}px;
  `};

  .hexagon {
    display: none;
  }

  .orange-link {
    font-size: inherit;
  }

  .link-arrow {
    display: none;
  }

  .description-title {
    font-size: ${({ theme }) => theme.fontSizes[19]}px;
    font-weight: ${({ theme }) => theme.fontWeight[6]};
    line-height: 75px;
    text-transform: uppercase;
    text-align: left;
    width: 100%;

    ${({ theme }) => theme.below.laptop`
      font-size: ${theme.fontSizes[5]}px;
      line-height: ${theme.lineHeight[5]}px;
    `}
  }

  .description-subtitle {
    padding: 0;
    color: ${({ theme }) => theme.colors.secondary};
    font-size: ${({ theme }) => theme.fontSizes[17]}px;
    font-weight: ${({ theme }) => theme.fontWeight[2]};
    line-height: ${({ theme }) => theme.lineHeight[2]}px;
    text-align: justify;

    ${({ theme }) => theme.below.laptop`
      font-size: ${theme.fontSizes[3]}px;
      line-height: ${theme.fontSizes[3]}px;
    `}

    ${({ theme }) => theme.below.mobileL`
      font-size: ${theme.fontSizes[2]}px;
      line-height: ${theme.fontSizes[2]}px;
    `}
  }

  .card-container {
    width: 100%;
    justify-content: space-around;

    ${({ theme }) => theme.above.laptopL`
      max-width: 998px;
    `}
  }

  .container {
    align-items: center;
    display: flex;

    h3 {
      -webkit-background-clip: text;
      background-clip: text;
      background-color: ${({ theme }) => theme.colors.secondary};
      background-image: ${({ theme }) => theme.newColors.gradientGreen};
      color: transparent;
      font-size: ${({ theme }) => theme.fontSizes[8]}px;
      line-height: ${({ theme }) =>
        theme.lineHeight[8] + theme.lineHeight[0]}px;

      ${({ theme }) => theme.below.tablet`
        font-size: ${theme.fontSizes[7]}px;
      `}
    }

    p {
      color: ${({ theme }) => theme.colors.secondary};
      font-size: ${({ theme }) => theme.fontSizes[15]}px;
      font-weight: ${({ theme }) => theme.fontWeight[6]};
      line-height: ${({ theme }) => theme.lineHeight[2]}px;
      text-transform: uppercase;
      ${({ theme }) => theme.below.tablet`
        font-size: ${theme.fontSizes[4]}px;
        line-height: ${theme.lineHeight[1]}px;
        margin-top: 0;
      `}
    }
  }
`
